export class UmstallenGruppeFrageDialogResult {
    confirmed: boolean;
    result: 'neu' | 'auswahl';
}
